module.exports = __webpack_public_path__ + "static/media/tl_cardholderadd.e1743e2a.svg";